import { connect } from 'react-redux';
import PoliticaContaDigitalUpdate from './politicaContaDigitalUpdate';

export default connect()(PoliticaContaDigitalUpdate);
